import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminPayments = lazy(() => import("@/pages/admin/AdminPayments"));

export const Route = createFileRoute("/admin/payments")({
  component: AdminPayments,
});
